/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

import React, {Fragment, useRef} from 'react'
import PropTypes from 'prop-types'
import {
    Box,
    Popover,
    PopoverContent,
    PopoverBody,
    useDisclosure,
    useTheme
} from '@salesforce/retail-react-app/app/components/shared/ui'
import {MobileListMenuContent} from '../mobile-list-menu/mobile-list-menu-content'
import {MobileListMenuTrigger} from '../mobile-list-menu/mobile-list-menu-trigger'

const MobileListMenuPopover = ({contentComponent, item, name, itemsKey, maxColumns}) => {
    const initialFocusRef = useRef()
    const {isOpen, onClose, onOpen} = useDisclosure()
    const ContentComponent = contentComponent || MobileListMenuContent
    const theme = useTheme()
    const {baseStyle} = theme.components.ListMenu

    return (
        <Box onMouseLeave={onClose}>
            <Popover
                isLazy
                placement={'bottom-start'}
                initialFocusRef={initialFocusRef}
                onOpen={onOpen}
                onClose={onClose}
                isOpen={isOpen}
                variant="fullWidth"
            >
                <Fragment>
                    <MobileListMenuTrigger
                        item={item}
                        name={name}
                        isOpen={isOpen}
                        onOpen={onOpen}
                        onClose={onClose}
                    />
                    {isOpen && (
                        <PopoverContent data-testid="popover-menu" {...baseStyle.popoverContent}>
                            <PopoverBody {...baseStyle.popoverBody}>
                                <ContentComponent
                                    item={item}
                                    itemsKey={itemsKey}
                                    initialFocusRef={initialFocusRef}
                                    onClose={onClose}
                                    maxColumns={maxColumns}
                                />
                            </PopoverBody>
                        </PopoverContent>
                    )}
                </Fragment>
            </Popover>
        </Box>
    )
}

MobileListMenuPopover.propTypes = {
    contentComponent: PropTypes.elementType,
    item: PropTypes.object,
    name: PropTypes.string,
    maxColumns: PropTypes.number,
    itemsKey: PropTypes.string
}

export {MobileListMenuPopover}
